import React from 'react';
import { MapPinIcon, ClipboardCheckIcon, TruckIcon, CreditCardIcon, PartyPopperIcon, ListIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { SectionHeading } from './ui/SectionHeading';
import { WHATSAPP_ORDER_LINK } from '../utils/whatsapp';
const info = [{
  icon: MapPinIcon,
  label: 'Ubicación',
  value: 'Costa Rica'
}, {
  icon: ClipboardCheckIcon,
  label: 'Pedidos',
  value: 'Sujetos a disponibilidad'
}, {
  icon: TruckIcon,
  label: 'Entrega / retiro',
  value: 'Consultar por WhatsApp'
}, {
  icon: CreditCardIcon,
  label: 'Pagos',
  value: '[Completar métodos reales]'
}, {
  icon: PartyPopperIcon,
  label: 'Eventos',
  value: 'Disponibles bajo consulta'
}, {
  icon: ListIcon,
  label: 'Menú',
  value: 'Puede variar según producción'
}];
export function BeforeOrdering() {
  return <section className="w-full bg-white px-4 py-16 sm:px-6 sm:py-20" data-id="element-14" data-mp="2vjt0tcihmxrb">
      <div className="mx-auto w-full max-w-6xl" data-id="element-15" data-mp="2zklbma70dapp">
        <SectionHeading title="Antes de pedir" subtitle="Para confirmar sabores, disponibilidad y coordinación, escribinos por WhatsApp." data-id="element-16" data-mp="2zja7285qnyxj" />

        <ul className="mt-10 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-17" data-mp="1pr8yyt1juv0x">
          {info.map(({
          icon: Icon,
          label,
          value
        }) => <li key={label} className="flex items-start gap-3 rounded-2xl border border-aqua-200 bg-cream p-4" data-id="element-18" data-mp="24geti3pfzx2h">
              <Icon className="mt-0.5 h-5 w-5 shrink-0 text-aqua-600" aria-hidden="true" data-id="element-19" data-mp="1brpq1y0wzfnk" />
              <div data-id="element-20" data-mp="16uze9mw5767y">
                <p className="font-display text-[11px] uppercase tracking-[0.2em] text-gold-500" data-id="element-21" data-mp="16vslsq2xdzr5">
                  {label}
                </p>
                <p className="mt-1 text-[13.5px] text-night-900" data-id="element-22" data-mp="1grcdt1edceam">{value}</p>
              </div>
            </li>)}
        </ul>

        <div className="mt-8 flex justify-center" data-id="element-23" data-mp="2x40xve6hv5qe">
          <CtaButton href={WHATSAPP_ORDER_LINK} track="whatsapp-info-click" data-id="element-24" data-mp="2s7ak4xi5wm85">
            Pedir por WhatsApp
          </CtaButton>
        </div>
      </div>
    </section>;
}